/* ═══════════════════════════════════════════════════════
   PIPE REFERENCE DATA — Static tables for PipeSizing page
   ═══════════════════════════════════════════════════════ */

// Steel Pipe – Schedule 40
export const steelHeaders = ["Nominal", "OD (in)", "ID (in)", "Wall (in)", "Weight (lb/ft)"];
export const steelRows: (string | number)[][] = [
  ["1/8\"",  0.405, 0.269, 0.068,  0.24],
  ["1/4\"",  0.540, 0.364, 0.088,  0.42],
  ["3/8\"",  0.675, 0.493, 0.091,  0.57],
  ["1/2\"",  0.840, 0.622, 0.109,  0.85],
  ["3/4\"",  1.050, 0.824, 0.113,  1.13],
  ["1\"",    1.315, 1.049, 0.133,  1.68],
  ["1-1/4\"",1.660, 1.380, 0.140,  2.27],
  ["1-1/2\"",1.900, 1.610, 0.145,  2.72],
  ["2\"",    2.375, 2.067, 0.154,  3.65],
  ["2-1/2\"",2.875, 2.469, 0.203,  5.79],
  ["3\"",    3.500, 3.068, 0.216,  7.58],
  ["3-1/2\"",4.000, 3.548, 0.226,  9.11],
  ["4\"",    4.500, 4.026, 0.237, 10.79],
  ["5\"",    5.563, 5.047, 0.258, 14.62],
  ["6\"",    6.625, 6.065, 0.280, 18.97],
  ["8\"",    8.625, 7.981, 0.322, 28.55],
  ["10\"",  10.750,10.020, 0.365, 40.48],
  ["12\"",  12.750,12.000, 0.375, 49.56],
  ["14\"",  14.000,13.250, 0.375, 54.57],
  ["16\"",  16.000,15.250, 0.375, 62.58],
  ["18\"",  18.000,17.250, 0.375, 70.59],
  ["20\"",  20.000,19.250, 0.375, 78.60],
  ["24\"",  24.000,23.250, 0.375, 94.62],
  ["30\"",  30.000,29.250, 0.375,118.65],
  ["36\"",  36.000,35.250, 0.375,142.68],
  ["42\"",  42.000,41.250, 0.375,166.71],
  ["48\"",  48.000,47.250, 0.375,190.74],
];

// Copper Pipe – Types K, L, M
export const copperHeaders = ["Type", "Nominal", "OD (in)", "ID (in)", "Wall (in)"];
export const copperRows: (string | number)[][] = [
  ["K","1/4\"", 0.375, 0.305, 0.035],
  ["K","3/8\"", 0.500, 0.402, 0.049],
  ["K","1/2\"", 0.625, 0.527, 0.049],
  ["K","5/8\"", 0.750, 0.652, 0.049],
  ["K","3/4\"", 0.875, 0.745, 0.065],
  ["K","1\"",   1.125, 0.995, 0.065],
  ["K","1-1/4\"",1.375,1.245, 0.065],
  ["K","1-1/2\"",1.625,1.481, 0.072],
  ["K","2\"",   2.125, 1.959, 0.083],
  ["K","2-1/2\"",2.625,2.435, 0.095],
  ["K","3\"",   3.125, 2.907, 0.109],
  ["K","3-1/2\"",3.625,3.385, 0.120],
  ["K","4\"",   4.125, 3.857, 0.134],
  ["K","5\"",   5.125, 4.805, 0.160],
  ["K","6\"",   6.125, 5.741, 0.192],
  ["K","8\"",   8.125, 7.583, 0.271],
  ["K","10\"", 10.125, 9.449, 0.338],
  ["K","12\"", 12.125,11.315, 0.405],
  ["L","1/4\"", 0.375, 0.315, 0.030],
  ["L","3/8\"", 0.500, 0.430, 0.035],
  ["L","1/2\"", 0.625, 0.545, 0.040],
  ["L","5/8\"", 0.750, 0.666, 0.042],
  ["L","3/4\"", 0.875, 0.785, 0.045],
  ["L","1\"",   1.125, 1.025, 0.050],
  ["L","1-1/4\"",1.375,1.265, 0.055],
  ["L","1-1/2\"",1.625,1.505, 0.060],
  ["L","2\"",   2.125, 1.985, 0.070],
  ["L","2-1/2\"",2.625,2.465, 0.080],
  ["L","3\"",   3.125, 2.945, 0.090],
  ["L","3-1/2\"",3.625,3.425, 0.100],
  ["L","4\"",   4.125, 3.905, 0.110],
  ["L","5\"",   5.125, 4.875, 0.125],
  ["L","6\"",   6.125, 5.845, 0.140],
  ["L","8\"",   8.125, 7.725, 0.200],
  ["L","10\"", 10.125, 9.625, 0.250],
  ["L","12\"", 12.125,11.565, 0.280],
  ["M","1/2\"", 0.625, 0.569, 0.028],
  ["M","3/4\"", 0.875, 0.811, 0.032],
  ["M","1\"",   1.125, 1.055, 0.035],
  ["M","1-1/4\"",1.375,1.291, 0.042],
  ["M","1-1/2\"",1.625,1.527, 0.049],
  ["M","2\"",   2.125, 2.009, 0.058],
  ["M","2-1/2\"",2.625,2.495, 0.065],
  ["M","3\"",   3.125, 2.981, 0.072],
  ["M","3-1/2\"",3.625,3.459, 0.083],
  ["M","4\"",   4.125, 3.935, 0.095],
  ["M","5\"",   5.125, 4.907, 0.109],
  ["M","6\"",   6.125, 5.881, 0.122],
  ["M","8\"",   8.125, 7.785, 0.170],
  ["M","10\"", 10.125, 9.701, 0.212],
  ["M","12\"", 12.125,11.617, 0.254],
];

// PVC Pipe – Schedule 40 & 80
export const pvcHeaders = ["Schedule", "Nominal", "OD (in)", "ID (in)", "Wall (in)", "PSI Rating"];
export const pvcRows: (string | number)[][] = [
  ["40","1/4\"", 0.540, 0.364, 0.088, 780],
  ["40","3/8\"", 0.675, 0.493, 0.091, 620],
  ["40","1/2\"", 0.840, 0.622, 0.109, 600],
  ["40","3/4\"", 1.050, 0.824, 0.113, 480],
  ["40","1\"",   1.315, 1.049, 0.133, 450],
  ["40","1-1/4\"",1.660,1.380, 0.140, 370],
  ["40","1-1/2\"",1.900,1.610, 0.145, 330],
  ["40","2\"",   2.375, 2.067, 0.154, 280],
  ["40","2-1/2\"",2.875,2.469, 0.203, 300],
  ["40","3\"",   3.500, 3.068, 0.216, 260],
  ["40","3-1/2\"",4.000,3.548, 0.226, 240],
  ["40","4\"",   4.500, 4.026, 0.237, 220],
  ["40","5\"",   5.563, 5.047, 0.258, 190],
  ["40","6\"",   6.625, 6.065, 0.280, 180],
  ["40","8\"",   8.625, 7.981, 0.322, 160],
  ["40","10\"", 10.750,10.020, 0.365, 140],
  ["40","12\"", 12.750,12.000, 0.375, 130],
  ["80","1/4\"", 0.540, 0.302, 0.119,1130],
  ["80","3/8\"", 0.675, 0.423, 0.126, 920],
  ["80","1/2\"", 0.840, 0.546, 0.147, 850],
  ["80","3/4\"", 1.050, 0.742, 0.154, 690],
  ["80","1\"",   1.315, 0.957, 0.179, 630],
  ["80","1-1/4\"",1.660,1.278, 0.191, 520],
  ["80","1-1/2\"",1.900,1.500, 0.200, 470],
  ["80","2\"",   2.375, 1.939, 0.218, 400],
  ["80","2-1/2\"",2.875,2.323, 0.276, 420],
  ["80","3\"",   3.500, 2.900, 0.300, 370],
  ["80","3-1/2\"",4.000,3.364, 0.318, 350],
  ["80","4\"",   4.500, 3.826, 0.337, 320],
  ["80","5\"",   5.563, 4.768, 0.375, 290],
  ["80","6\"",   6.625, 5.761, 0.432, 280],
  ["80","8\"",   8.625, 7.625, 0.500, 250],
  ["80","10\"", 10.750, 9.564, 0.593, 230],
  ["80","12\"", 12.750,11.376, 0.687, 230],
];

// CPVC Pipe – Schedule 80
export const cpvcHeaders = ["Nominal", "OD (in)", "ID (in)", "Wall (in)", "PSI @ 180°F"];
export const cpvcRows: (string | number)[][] = [
  ["1/4\"", 0.540, 0.302, 0.119, 450],
  ["3/8\"", 0.675, 0.423, 0.126, 370],
  ["1/2\"", 0.840, 0.546, 0.147, 340],
  ["3/4\"", 1.050, 0.742, 0.154, 275],
  ["1\"",   1.315, 0.957, 0.179, 250],
  ["1-1/4\"",1.660,1.278, 0.191, 210],
  ["1-1/2\"",1.900,1.500, 0.200, 190],
  ["2\"",   2.375, 1.939, 0.218, 160],
  ["2-1/2\"",2.875,2.323, 0.276, 170],
  ["3\"",   3.500, 2.900, 0.300, 150],
  ["4\"",   4.500, 3.826, 0.337, 130],
  ["6\"",   6.625, 5.761, 0.432, 110],
  ["8\"",   8.625, 7.625, 0.500, 100],
];

// Stainless Steel – Schedule 10S & 40S
export const ssHeaders = ["Schedule", "Nominal", "OD (in)", "ID (in)", "Wall (in)", "Weight (lb/ft)"];
export const ssRows: (string | number)[][] = [
  ["10S","1/2\"", 0.840, 0.732, 0.049, 0.43],
  ["10S","3/4\"", 1.050, 0.884, 0.083, 0.86],
  ["10S","1\"",   1.315, 1.097, 0.109, 1.40],
  ["10S","1-1/4\"",1.660,1.442, 0.109, 1.81],
  ["10S","1-1/2\"",1.900,1.682, 0.109, 2.09],
  ["10S","2\"",   2.375, 2.157, 0.109, 2.64],
  ["10S","2-1/2\"",2.875,2.635, 0.120, 3.53],
  ["10S","3\"",   3.500, 3.260, 0.120, 4.33],
  ["10S","3-1/2\"",4.000,3.760, 0.120, 4.97],
  ["10S","4\"",   4.500, 4.260, 0.120, 5.61],
  ["10S","5\"",   5.563, 5.295, 0.134, 7.77],
  ["10S","6\"",   6.625, 6.357, 0.134, 9.29],
  ["10S","8\"",   8.625, 8.329, 0.148,13.40],
  ["10S","10\"", 10.750,10.420, 0.165,18.65],
  ["10S","12\"", 12.750,12.390, 0.180,24.17],
  ["40S","1/2\"", 0.840, 0.622, 0.109, 0.85],
  ["40S","3/4\"", 1.050, 0.824, 0.113, 1.13],
  ["40S","1\"",   1.315, 1.049, 0.133, 1.68],
  ["40S","1-1/4\"",1.660,1.380, 0.140, 2.27],
  ["40S","1-1/2\"",1.900,1.610, 0.145, 2.72],
  ["40S","2\"",   2.375, 2.067, 0.154, 3.65],
  ["40S","2-1/2\"",2.875,2.469, 0.203, 5.79],
  ["40S","3\"",   3.500, 3.068, 0.216, 7.58],
  ["40S","3-1/2\"",4.000,3.548, 0.226, 9.11],
  ["40S","4\"",   4.500, 4.026, 0.237,10.79],
  ["40S","5\"",   5.563, 5.047, 0.258,14.62],
  ["40S","6\"",   6.625, 6.065, 0.280,18.97],
  ["40S","8\"",   8.625, 7.981, 0.322,28.55],
  ["40S","10\"", 10.750,10.020, 0.365,40.48],
  ["40S","12\"", 12.750,12.000, 0.375,49.56],
];

// Cast Iron – Service & Extra Heavy
export const ciHeaders = ["Class", "Nominal", "OD (in)", "ID (in)", "Wall (in)", "Weight (lb/ft)"];
export const ciRows: (string | number)[][] = [
  ["SV","1-1/2\"",1.50, 1.46, 0.12,  2.75],
  ["SV","2\"",   2.00, 1.96, 0.12,  3.50],
  ["SV","3\"",   3.00, 2.96, 0.12,  4.50],
  ["SV","4\"",   4.19, 4.00, 0.095, 4.75],
  ["SV","5\"",   5.19, 5.00, 0.095, 5.90],
  ["SV","6\"",   6.19, 6.00, 0.095, 7.00],
  ["SV","8\"",   8.19, 8.00, 0.095, 9.00],
  ["SV","10\"", 10.19,10.00, 0.095,11.00],
  ["SV","12\"", 12.19,12.00, 0.095,13.25],
  ["SV","15\"", 15.19,15.00, 0.095,17.00],
  ["XH","2\"",   2.38, 2.00, 0.19,  5.13],
  ["XH","3\"",   3.50, 3.00, 0.25,  8.50],
  ["XH","4\"",   4.50, 4.00, 0.25, 12.00],
  ["XH","5\"",   5.50, 5.00, 0.25, 15.50],
  ["XH","6\"",   6.50, 6.00, 0.25, 19.00],
  ["XH","8\"",   8.63, 8.00, 0.31, 28.00],
  ["XH","10\"", 10.75,10.00, 0.38, 43.00],
  ["XH","12\"", 12.75,12.00, 0.38, 54.00],
  ["XH","15\"", 15.88,15.00, 0.44, 75.00],
];

// Pipe Support Spacing
export const supportHeaders = ["Nominal", "Steel", "Copper", "PVC", "CPVC", "Cast Iron"];
export const supportRows: (string | number)[][] = [
  ["1/2\"",  7,  5, 4.5, 3, "—"],
  ["3/4\"",  7,  5, 4.5, 3, "—"],
  ["1\"",    7,  6, 5,   4, "—"],
  ["1-1/4\"",7,  7, 5,   4, "—"],
  ["1-1/2\"",9,  8, 5,   4,  5 ],
  ["2\"",    10, 8, 5,   4,  5 ],
  ["2-1/2\"",11, 9, 5,   4,  5 ],
  ["3\"",    12,10, 5,   4,  5 ],
  ["4\"",    14,12, 5,   4,  5 ],
  ["6\"",    17,14, 5,   4,  5 ],
  ["8\"",    19,"—",5,  "—",  8 ],
  ["10\"",   22,"—","—","—",  8 ],
  ["12\"",   23,"—","—","—", 10 ],
  ["14\"",   25,"—","—","—", 10 ],
  ["16\"",   27,"—","—","—", 12 ],
  ["18\"",   28,"—","—","—", 12 ],
  ["20\"",   30,"—","—","—", 12 ],
  ["24\"",   32,"—","—","—", 14 ],
  ["30\"",   35,"—","—","—","—"],
  ["36\"",   37,"—","—","—","—"],
  ["42\"",   40,"—","—","—","—"],
  ["48\"",   42,"—","—","—","—"],
];

// Fitting Dimensions – Butt-weld steel (ANSI B16.9)
export const fittingHeaders = ["Nominal", "90° Elbow (in)", "45° Elbow (in)", "Tee Run (in)", "Tee Branch (in)", "Con. Reducer (in)"];
export const fittingRows: (string | number)[][] = [
  ["1/2\"",   1.00, 0.63,  1.00, 1.00,  "—"],
  ["3/4\"",   1.13, 0.75,  1.13, 1.13,  "—"],
  ["1\"",     1.50, 0.88,  1.50, 1.50,  2.00],
  ["1-1/4\"", 1.88, 1.09,  1.88, 1.88,  2.50],
  ["1-1/2\"", 2.25, 1.31,  2.25, 2.25,  3.00],
  ["2\"",     3.00, 1.63,  3.00, 3.00,  3.50],
  ["2-1/2\"", 3.75, 1.94,  3.75, 3.75,  3.50],
  ["3\"",     4.50, 2.25,  4.50, 4.50,  4.00],
  ["4\"",     6.00, 3.00,  6.00, 6.00,  5.00],
  ["5\"",     7.50, 3.75,  7.50, 7.50,  5.50],
  ["6\"",     9.00, 4.50,  9.00, 9.00,  6.00],
  ["8\"",    12.00, 6.00, 12.00,12.00,  7.00],
  ["10\"",   15.00, 7.50, 15.00,15.00,  8.00],
  ["12\"",   18.00, 9.00, 18.00,18.00,  8.00],
  ["14\"",   21.00,10.50, 21.00,21.00,  9.00],
  ["16\"",   24.00,12.00, 24.00,24.00, 10.00],
  ["18\"",   27.00,13.50, 27.00,27.00, 11.00],
  ["20\"",   30.00,15.00, 30.00,30.00, 12.00],
  ["24\"",   36.00,18.00, 36.00,36.00, 14.00],
];

// Thread Engagement & Tap Drill — Combined Table
export const threadTapHeaders = ["Size", "Type", "TPI", "Engage / Tap Drill", "Pitch / Decimal (in)", "Min Turns / % Thread"];
export const threadTapRows: (string | number)[][] = [
  // Thread Engagement — NPT
  ["1/8\" NPT",   "Thread", 27,   "0.264\"",  0.0370, "7.1 turns"],
  ["1/4\" NPT",   "Thread", 18,   "0.402\"",  0.0556, "7.2 turns"],
  ["3/8\" NPT",   "Thread", 18,   "0.408\"",  0.0556, "7.3 turns"],
  ["1/2\" NPT",   "Thread", 14,   "0.534\"",  0.0714, "7.5 turns"],
  ["3/4\" NPT",   "Thread", 14,   "0.546\"",  0.0714, "7.6 turns"],
  ["1\" NPT",     "Thread", 11.5, "0.683\"",  0.0870, "7.9 turns"],
  ["1-1/4\" NPT", "Thread", 11.5, "0.707\"",  0.0870, "8.1 turns"],
  ["1-1/2\" NPT", "Thread", 11.5, "0.724\"",  0.0870, "8.3 turns"],
  ["2\" NPT",     "Thread", 11.5, "0.756\"",  0.0870, "8.7 turns"],
  ["2-1/2\" NPT", "Thread", 8,    "1.138\"",  0.1250, "9.1 turns"],
  ["3\" NPT",     "Thread", 8,    "1.200\"",  0.1250, "9.6 turns"],
  ["4\" NPT",     "Thread", 8,    "1.300\"",  0.1250, "10.4 turns"],
  ["6\" NPT",     "Thread", 8,    "1.513\"",  0.1250, "12.1 turns"],
  // Thread Engagement — UNC/UNF
  ["#6-32 UNC",   "Thread", 32,   "0.188\"",  0.0313, "6.0 turns"],
  ["#8-32 UNC",   "Thread", 32,   "0.188\"",  0.0313, "6.0 turns"],
  ["#10-24 UNC",  "Thread", 24,   "0.250\"",  0.0417, "6.0 turns"],
  ["1/4\"-20 UNC","Thread", 20,   "0.375\"",  0.0500, "7.5 turns"],
  ["3/8\"-16 UNC","Thread", 16,   "0.438\"",  0.0625, "7.0 turns"],
  ["1/2\"-13 UNC","Thread", 13,   "0.500\"",  0.0769, "6.5 turns"],
  ["5/8\"-11 UNC","Thread", 11,   "0.563\"",  0.0909, "6.2 turns"],
  ["3/4\"-10 UNC","Thread", 10,   "0.625\"",  0.1000, "6.3 turns"],
  ["7/8\"-9 UNC", "Thread", 9,    "0.688\"",  0.1111, "6.2 turns"],
  ["1\"-8 UNC",   "Thread", 8,    "0.750\"",  0.1250, "6.0 turns"],
  // Tap Drills — UNC
  ["#4-40 UNC",   "Tap",   40,   "#43",      0.0890, "75%"],
  ["#6-32 UNC",   "Tap",   32,   "#36",      0.1065, "75%"],
  ["#8-32 UNC",   "Tap",   32,   "#29",      0.1360, "75%"],
  ["#10-24 UNC",  "Tap",   24,   "#25",      0.1495, "75%"],
  ["1/4\"-20 UNC","Tap",   20,   "#7",       0.2010, "75%"],
  ["5/16\"-18 UNC","Tap",  18,   "F",        0.2570, "75%"],
  ["3/8\"-16 UNC","Tap",   16,   "5/16\"",   0.3125, "75%"],
  ["7/16\"-14 UNC","Tap",  14,   "U",        0.3680, "75%"],
  ["1/2\"-13 UNC","Tap",   13,   "27/64\"",  0.4219, "75%"],
  ["5/8\"-11 UNC","Tap",   11,   "17/32\"",  0.5312, "75%"],
  ["3/4\"-10 UNC","Tap",   10,   "21/32\"",  0.6562, "75%"],
  ["7/8\"-9 UNC", "Tap",   9,    "49/64\"",  0.7656, "75%"],
  ["1\"-8 UNC",   "Tap",   8,    "7/8\"",    0.8750, "75%"],
  // Tap Drills — UNF
  ["#10-32 UNF",  "Tap",   32,   "#21",      0.1590, "75%"],
  ["1/4\"-28 UNF","Tap",   28,   "#3",       0.2130, "75%"],
  ["5/16\"-24 UNF","Tap",  24,   "I",        0.2720, "75%"],
  ["3/8\"-24 UNF","Tap",   24,   "Q",        0.3320, "75%"],
  ["1/2\"-20 UNF","Tap",   20,   "29/64\"",  0.4531, "75%"],
  ["5/8\"-18 UNF","Tap",   18,   "37/64\"",  0.5781, "75%"],
  ["3/4\"-16 UNF","Tap",   16,   "11/16\"",  0.6875, "75%"],
  ["7/8\"-14 UNF","Tap",   14,   "13/16\"",  0.8125, "75%"],
  ["1\"-14 UNF",  "Tap",   14,   "15/16\"",  0.9375, "75%"],
  // Tap Drills — NPT
  ["1/8\" NPT",   "Tap",   27,   "R",        0.3390, "—"],
  ["1/4\" NPT",   "Tap",   18,   "7/16\"",   0.4375, "—"],
  ["3/8\" NPT",   "Tap",   18,   "37/64\"",  0.5781, "—"],
  ["1/2\" NPT",   "Tap",   14,   "23/32\"",  0.7188, "—"],
  ["3/4\" NPT",   "Tap",   14,   "59/64\"",  0.9219, "—"],
  ["1\" NPT",     "Tap",   11.5, "1-5/32\"", 1.1562, "—"],
  ["1-1/4\" NPT", "Tap",   11.5, "1-1/2\"",  1.5000, "—"],
  ["1-1/2\" NPT", "Tap",   11.5, "1-47/64\"",1.7344, "—"],
  ["2\" NPT",     "Tap",   11.5, "2-3/16\"", 2.1875, "—"],
];

// Bolt Torque – Common SAE Grade 5 & 8, Stainless
export const boltTorqueHeaders = ["Bolt Size", "Grade", "Clamp (lbs)", "Torque (ft-lb)", "Lubed (ft-lb)"];
export const boltTorqueRows: (string | number)[][] = [
  ["1/4\"-20",  "Gr 5",  2025,   8,   6],
  ["1/4\"-20",  "Gr 8",  2850,  12,   9],
  ["1/4\"-20",  "SS 18-8", 1600,  6,   5],
  ["5/16\"-18", "Gr 5",  3300,  17,  13],
  ["5/16\"-18", "Gr 8",  4650,  24,  18],
  ["5/16\"-18", "SS 18-8", 2650, 14,  10],
  ["3/8\"-16",  "Gr 5",  4950,  31,  23],
  ["3/8\"-16",  "Gr 8",  6950,  44,  33],
  ["3/8\"-16",  "SS 18-8", 3950, 25,  19],
  ["7/16\"-14", "Gr 5",  6800,  49,  37],
  ["7/16\"-14", "Gr 8",  9600,  70,  53],
  ["7/16\"-14", "SS 18-8", 5400, 39,  30],
  ["1/2\"-13",  "Gr 5",  9050,  75,  56],
  ["1/2\"-13",  "Gr 8",  12750, 106,  80],
  ["1/2\"-13",  "SS 18-8", 7200, 60,  45],
  ["9/16\"-12", "Gr 5",  11700, 110,  82],
  ["9/16\"-12", "Gr 8",  16500, 155, 116],
  ["9/16\"-12", "SS 18-8", 9350, 88,  66],
  ["5/8\"-11",  "Gr 5",  14500, 150, 113],
  ["5/8\"-11",  "Gr 8",  20400, 212, 159],
  ["5/8\"-11",  "SS 18-8",11550,120,  90],
  ["3/4\"-10",  "Gr 5",  21300, 266, 200],
  ["3/4\"-10",  "Gr 8",  30000, 375, 281],
  ["3/4\"-10",  "SS 18-8",16950,212, 159],
  ["7/8\"-9",   "Gr 5",  29600, 430, 323],
  ["7/8\"-9",   "Gr 8",  41650, 606, 455],
  ["7/8\"-9",   "SS 18-8",23550,343, 257],
  ["1\"-8",     "Gr 5",  38750, 644, 483],
  ["1\"-8",     "Gr 8",  54600, 908, 681],
  ["1\"-8",     "SS 18-8",30850,514, 385],
  ["1-1/8\"-7", "Gr 5",  44050, 824, 618],
  ["1-1/8\"-7", "Gr 8",  62050,1161, 871],
  ["1-1/4\"-7", "Gr 5",  55350,1150, 863],
  ["1-1/4\"-7", "Gr 8",  77950,1620,1215],
  ["1-1/2\"-6", "Gr 5",  80600,2010,1507],
  ["1-1/2\"-6", "Gr 8", 113500,2832,2124],
];

// Flange Bolt Patterns (ASME B16.5)
export const flangeBoltHeaders = ["Pipe Size", "Class", "# Bolts", "Bolt Dia", "Bolt Circle (in)", "Flange OD (in)"];
export const flangeBoltRows: (string | number)[][] = [
  ["1/2\"",   "150#", 4, "1/2\"",  2.38,  3.50],
  ["1/2\"",   "300#", 4, "1/2\"",  2.62,  3.75],
  ["3/4\"",   "150#", 4, "1/2\"",  2.75,  3.88],
  ["3/4\"",   "300#", 4, "5/8\"",  3.25,  4.62],
  ["1\"",     "150#", 4, "1/2\"",  3.12,  4.25],
  ["1\"",     "300#", 4, "5/8\"",  3.50,  4.88],
  ["1-1/4\"", "150#", 4, "1/2\"",  3.50,  4.62],
  ["1-1/4\"", "300#", 4, "5/8\"",  3.88,  5.25],
  ["1-1/2\"", "150#", 4, "1/2\"",  3.88,  5.00],
  ["1-1/2\"", "300#", 4, "3/4\"",  4.50,  6.12],
  ["2\"",     "150#", 4, "5/8\"",  4.75,  6.00],
  ["2\"",     "300#", 8, "5/8\"",  5.00,  6.50],
  ["2-1/2\"", "150#", 4, "5/8\"",  5.50,  7.00],
  ["2-1/2\"", "300#", 8, "3/4\"",  5.88,  7.50],
  ["3\"",     "150#", 4, "5/8\"",  6.00,  7.50],
  ["3\"",     "300#", 8, "3/4\"",  6.62,  8.25],
  ["4\"",     "150#", 8, "5/8\"",  7.50,  9.00],
  ["4\"",     "300#", 8, "3/4\"",  7.88,  10.75],
  ["5\"",     "150#", 8, "3/4\"",  8.50, 10.00],
  ["5\"",     "300#", 8, "3/4\"",  9.25, 11.00],
  ["6\"",     "150#", 8, "3/4\"",  9.50, 11.00],
  ["6\"",     "300#",12, "3/4\"", 10.62, 12.50],
  ["8\"",     "150#", 8, "3/4\"", 11.75, 13.50],
  ["8\"",     "300#",12, "7/8\"", 13.00, 15.00],
  ["10\"",    "150#",12, "7/8\"", 14.25, 16.00],
  ["10\"",    "300#",16, "1\"",   15.25, 17.50],
  ["12\"",    "150#",12, "7/8\"", 17.00, 19.00],
  ["12\"",    "300#",16, "1-1/8\"",17.75,20.50],
  ["14\"",    "150#",12, "1\"",   18.75, 21.00],
  ["14\"",    "300#",20, "1-1/8\"",20.25,23.00],
  ["16\"",    "150#",16, "1\"",   21.25, 23.50],
  ["16\"",    "300#",20, "1-1/4\"",22.50,25.50],
  ["18\"",    "150#",16, "1-1/8\"",22.75,25.00],
  ["18\"",    "300#",24, "1-1/4\"",24.75,28.00],
  ["20\"",    "150#",20, "1-1/8\"",25.00,27.50],
  ["20\"",    "300#",24, "1-1/4\"",27.00,30.50],
  ["24\"",    "150#",20, "1-1/4\"",29.50,32.00],
  ["24\"",    "300#",24, "1-1/2\"",32.00,36.00],
  // Class 600
  ["1/2\"",   "600#", 4, "5/8\"",  2.62,  3.75],
  ["3/4\"",   "600#", 4, "3/4\"",  3.25,  4.62],
  ["1\"",     "600#", 4, "3/4\"",  3.50,  4.88],
  ["1-1/4\"", "600#", 4, "3/4\"",  3.88,  5.25],
  ["1-1/2\"", "600#", 4, "7/8\"",  4.50,  6.12],
  ["2\"",     "600#", 8, "5/8\"",  5.00,  6.50],
  ["2-1/2\"", "600#", 8, "7/8\"",  5.88,  7.50],
  ["3\"",     "600#", 8, "7/8\"",  6.62,  8.25],
  ["4\"",     "600#", 8, "1\"",    7.88, 10.75],
  ["5\"",     "600#", 8, "1\"",    9.25, 11.00],
  ["6\"",     "600#",12, "1\"",   10.62, 12.50],
  ["8\"",     "600#",12, "1-1/8\"",13.00,15.00],
  ["10\"",    "600#",16, "1-1/4\"",15.25,17.50],
  ["12\"",    "600#",20, "1-1/4\"",17.75,20.50],
  ["14\"",    "600#",20, "1-3/8\"",20.25,23.00],
  ["16\"",    "600#",20, "1-1/2\"",22.50,25.50],
  ["18\"",    "600#",20, "1-5/8\"",24.75,28.00],
  ["20\"",    "600#",24, "1-5/8\"",27.00,30.50],
  ["24\"",    "600#",24, "1-7/8\"",32.00,36.00],
  // Class 900
  ["1/2\"",   "900#", 4, "3/4\"",  2.62,  3.75],
  ["3/4\"",   "900#", 4, "3/4\"",  3.25,  4.62],
  ["1\"",     "900#", 4, "7/8\"",  3.50,  4.88],
  ["1-1/4\"", "900#", 4, "7/8\"",  3.88,  5.25],
  ["1-1/2\"", "900#", 4, "1\"",    4.50,  6.12],
  ["2\"",     "900#", 8, "3/4\"",  5.00,  6.50],
  ["2-1/2\"", "900#", 8, "1\"",    5.88,  7.50],
  ["3\"",     "900#", 8, "7/8\"",  6.62,  8.25],
  ["4\"",     "900#", 8, "1-1/8\"",7.88, 10.75],
  ["5\"",     "900#", 8, "1-1/4\"",9.25, 11.00],
  ["6\"",     "900#",12, "1-1/8\"",10.62,12.50],
  ["8\"",     "900#",12, "1-3/8\"",13.00,15.00],
  ["10\"",    "900#",16, "1-3/8\"",15.25,17.50],
  ["12\"",    "900#",20, "1-3/8\"",17.75,20.50],
  ["14\"",    "900#",20, "1-1/2\"",20.25,23.00],
  ["16\"",    "900#",20, "1-3/4\"",22.50,25.50],
  ["18\"",    "900#",20, "2\"",    24.75,28.00],
  ["20\"",    "900#",24, "2\"",    27.00,30.50],
  ["24\"",    "900#",24, "2-1/4\"",32.00,36.00],
  // Class 1500
  ["1/2\"",   "1500#", 4, "7/8\"",  2.88,  3.75],
  ["3/4\"",   "1500#", 4, "1\"",    3.50,  4.62],
  ["1\"",     "1500#", 4, "1-1/8\"",3.75,  5.25],
  ["1-1/4\"", "1500#", 4, "1-1/8\"",4.00,  5.50],
  ["1-1/2\"", "1500#", 4, "1-1/4\"",4.88,  6.25],
  ["2\"",     "1500#", 8, "7/8\"",  5.50,  6.75],
  ["2-1/2\"", "1500#", 8, "1\"",    6.38,  8.50],
  ["3\"",     "1500#", 8, "1-1/8\"",6.88,  9.00],
  ["4\"",     "1500#", 8, "1-3/8\"",8.50, 11.50],
  ["5\"",     "1500#", 8, "1-1/2\"",10.50,13.75],
  ["6\"",     "1500#",12, "1-3/8\"",12.00,15.00],
  ["8\"",     "1500#",12, "1-5/8\"",14.50,18.50],
  ["10\"",    "1500#",12, "2\"",    17.00,21.50],
  ["12\"",    "1500#",16, "2\"",    19.25,24.00],
  ["14\"",    "1500#",16, "2-1/4\"",20.75,25.25],
  ["16\"",    "1500#",16, "2-1/2\"",23.75,28.50],
  ["18\"",    "1500#",16, "2-3/4\"",25.75,31.00],
  ["20\"",    "1500#",16, "3\"",    28.50,34.00],
  ["24\"",    "1500#",16, "3-1/2\"",33.00,39.00],
  // Class 2500
  ["1/2\"",   "2500#", 4, "7/8\"",  2.88,  4.75],
  ["3/4\"",   "2500#", 4, "1\"",    3.50,  5.12],
  ["1\"",     "2500#", 4, "1-1/8\"",3.75,  5.88],
  ["1-1/4\"", "2500#", 4, "1-1/4\"",4.25,  6.25],
  ["1-1/2\"", "2500#", 4, "1-3/8\"",4.88,  6.88],
  ["2\"",     "2500#", 8, "1\"",    5.75,  8.50],
  ["2-1/2\"", "2500#", 8, "1-1/8\"",6.75,  9.62],
  ["3\"",     "2500#", 8, "1-1/4\"",7.50, 10.50],
  ["4\"",     "2500#", 8, "1-1/2\"",9.50, 13.00],
  ["5\"",     "2500#", 8, "1-3/4\"",11.50,15.50],
  ["6\"",     "2500#", 8, "2\"",    12.75,17.00],
  ["8\"",     "2500#",12, "1-3/4\"",15.50,19.50],
  ["10\"",    "2500#",12, "2\"",    18.50,23.00],
  ["12\"",    "2500#",12, "2-1/2\"",21.00,26.50],
];

// Gasket Selection Reference (ASME B16.20 / B16.21)
export const gasketHeaders = ["Pipe Size", "Class", "Gasket Type", "ID (in)", "OD (in)", "Thickness (in)", "Material"];
export const gasketRows: (string | number)[][] = [
  ["1/2\"",   "150#", "Flat (RF)",       0.84,  1.88, 0.063, "Non-Asbestos"],
  ["3/4\"",   "150#", "Flat (RF)",       1.05,  2.38, 0.063, "Non-Asbestos"],
  ["1\"",     "150#", "Flat (RF)",       1.32,  2.75, 0.063, "Non-Asbestos"],
  ["1-1/2\"", "150#", "Flat (RF)",       1.90,  3.50, 0.063, "Non-Asbestos"],
  ["2\"",     "150#", "Flat (RF)",       2.38,  4.12, 0.063, "Non-Asbestos"],
  ["3\"",     "150#", "Flat (RF)",       3.50,  5.38, 0.063, "Non-Asbestos"],
  ["4\"",     "150#", "Flat (RF)",       4.50,  6.75, 0.063, "Non-Asbestos"],
  ["6\"",     "150#", "Flat (RF)",       6.63,  8.75, 0.063, "Non-Asbestos"],
  ["8\"",     "150#", "Flat (RF)",       8.63, 11.00, 0.063, "Non-Asbestos"],
  ["10\"",    "150#", "Flat (RF)",      10.75, 13.38, 0.063, "Non-Asbestos"],
  ["12\"",    "150#", "Flat (RF)",      12.75, 16.12, 0.063, "Non-Asbestos"],
  ["14\"",    "150#", "Flat (RF)",      14.00, 17.75, 0.063, "Non-Asbestos"],
  ["16\"",    "150#", "Flat (RF)",      16.00, 20.25, 0.063, "Non-Asbestos"],
  ["18\"",    "150#", "Flat (RF)",      18.00, 21.62, 0.063, "Non-Asbestos"],
  ["20\"",    "150#", "Flat (RF)",      20.00, 23.88, 0.063, "Non-Asbestos"],
  ["24\"",    "150#", "Flat (RF)",      24.00, 27.62, 0.063, "Non-Asbestos"],
  ["1/2\"",   "300#", "Spiral Wound",    0.84,  1.88, 0.175, "SS 304 / Graphite"],
  ["3/4\"",   "300#", "Spiral Wound",    1.05,  2.50, 0.175, "SS 304 / Graphite"],
  ["1\"",     "300#", "Spiral Wound",    1.32,  2.88, 0.175, "SS 304 / Graphite"],
  ["1-1/2\"", "300#", "Spiral Wound",    1.90,  3.75, 0.175, "SS 304 / Graphite"],
  ["2\"",     "300#", "Spiral Wound",    2.38,  4.50, 0.175, "SS 304 / Graphite"],
  ["3\"",     "300#", "Spiral Wound",    3.50,  5.88, 0.175, "SS 304 / Graphite"],
  ["4\"",     "300#", "Spiral Wound",    4.50,  7.25, 0.175, "SS 304 / Graphite"],
  ["6\"",     "300#", "Spiral Wound",    6.63,  9.25, 0.175, "SS 304 / Graphite"],
  ["8\"",     "300#", "Spiral Wound",    8.63, 11.75, 0.175, "SS 304 / Graphite"],
  ["10\"",    "300#", "Spiral Wound",   10.75, 14.25, 0.175, "SS 304 / Graphite"],
  ["12\"",    "300#", "Spiral Wound",   12.75, 17.00, 0.175, "SS 304 / Graphite"],
  ["14\"",    "300#", "Spiral Wound",   14.00, 18.75, 0.175, "SS 304 / Graphite"],
  ["16\"",    "300#", "Spiral Wound",   16.00, 21.25, 0.175, "SS 304 / Graphite"],
  ["18\"",    "300#", "Spiral Wound",   18.00, 23.00, 0.175, "SS 304 / Graphite"],
  ["20\"",    "300#", "Spiral Wound",   20.00, 25.25, 0.175, "SS 304 / Graphite"],
  ["24\"",    "300#", "Spiral Wound",   24.00, 29.50, 0.175, "SS 304 / Graphite"],
  ["1/2\"",   "600#", "Spiral Wound",    0.84,  1.88, 0.175, "SS 304 / Graphite"],
  ["1\"",     "600#", "Spiral Wound",    1.32,  2.88, 0.175, "SS 304 / Graphite"],
  ["2\"",     "600#", "Spiral Wound",    2.38,  4.50, 0.175, "SS 304 / Graphite"],
  ["3\"",     "600#", "Spiral Wound",    3.50,  5.88, 0.175, "SS 304 / Graphite"],
  ["4\"",     "600#", "Spiral Wound",    4.50,  7.25, 0.175, "SS 304 / Graphite"],
  ["6\"",     "600#", "Spiral Wound",    6.63,  9.25, 0.175, "SS 304 / Graphite"],
  ["8\"",     "600#", "Spiral Wound",    8.63, 11.75, 0.175, "SS 304 / Graphite"],
  ["10\"",    "600#", "Spiral Wound",   10.75, 14.25, 0.175, "SS 304 / Graphite"],
  ["12\"",    "600#", "Spiral Wound",   12.75, 17.00, 0.175, "SS 304 / Graphite"],
  ["16\"",    "600#", "Spiral Wound",   16.00, 21.25, 0.175, "SS 304 / Graphite"],
  ["20\"",    "600#", "Spiral Wound",   20.00, 25.25, 0.175, "SS 304 / Graphite"],
  ["24\"",    "600#", "Spiral Wound",   24.00, 29.50, 0.175, "SS 304 / Graphite"],
  ["1/2\"",   "900#", "Spiral Wound",    0.84,  1.88, 0.175, "SS 304 / Graphite"],
  ["1\"",     "900#", "Spiral Wound",    1.32,  2.88, 0.175, "SS 304 / Graphite"],
  ["2\"",     "900#", "Spiral Wound",    2.38,  4.50, 0.175, "SS 304 / Graphite"],
  ["3\"",     "900#", "Spiral Wound",    3.50,  5.88, 0.175, "SS 304 / Graphite"],
  ["4\"",     "900#", "Spiral Wound",    4.50,  7.25, 0.175, "SS 304 / Graphite"],
  ["6\"",     "900#", "Spiral Wound",    6.63,  9.25, 0.175, "SS 304 / Graphite"],
  ["8\"",     "900#", "Spiral Wound",    8.63, 11.75, 0.175, "SS 304 / Graphite"],
  ["10\"",    "900#", "Spiral Wound",   10.75, 14.25, 0.175, "SS 304 / Graphite"],
  ["12\"",    "900#", "Spiral Wound",   12.75, 17.00, 0.175, "SS 304 / Graphite"],
  ["16\"",    "900#", "Spiral Wound",   16.00, 21.25, 0.175, "SS 304 / Graphite"],
  ["20\"",    "900#", "Spiral Wound",   20.00, 25.25, 0.175, "SS 304 / Graphite"],
  ["24\"",    "900#", "Spiral Wound",   24.00, 29.50, 0.175, "SS 304 / Graphite"],
  ["1/2\"",   "1500#", "Ring Joint (RTJ)", 0.84,  1.88, "—", "SS 304 / R-11"],
  ["3/4\"",   "1500#", "Ring Joint (RTJ)", 1.05,  2.50, "—", "SS 304 / R-13"],
  ["1\"",     "1500#", "Ring Joint (RTJ)", 1.32,  2.88, "—", "SS 304 / R-16"],
  ["1-1/2\"", "1500#", "Ring Joint (RTJ)", 1.90,  3.75, "—", "SS 304 / R-20"],
  ["2\"",     "1500#", "Ring Joint (RTJ)", 2.38,  4.50, "—", "SS 304 / R-24"],
  ["3\"",     "1500#", "Ring Joint (RTJ)", 3.50,  5.88, "—", "SS 304 / R-31"],
  ["4\"",     "1500#", "Ring Joint (RTJ)", 4.50,  7.25, "—", "SS 304 / R-37"],
  ["6\"",     "1500#", "Ring Joint (RTJ)", 6.63,  9.25, "—", "SS 304 / R-45"],
  ["8\"",     "1500#", "Ring Joint (RTJ)", 8.63, 11.75, "—", "SS 304 / R-49"],
  ["10\"",    "1500#", "Ring Joint (RTJ)",10.75, 14.25, "—", "SS 304 / R-53"],
  ["12\"",    "1500#", "Ring Joint (RTJ)",12.75, 17.00, "—", "SS 304 / R-57"],
  ["14\"",    "1500#", "Ring Joint (RTJ)",14.00, 18.75, "—", "SS 304 / R-61"],
  ["16\"",    "1500#", "Ring Joint (RTJ)",16.00, 21.25, "—", "SS 304 / R-65"],
  ["18\"",    "1500#", "Ring Joint (RTJ)",18.00, 23.00, "—", "SS 304 / R-69"],
  ["20\"",    "1500#", "Ring Joint (RTJ)",20.00, 25.25, "—", "SS 304 / R-73"],
  ["24\"",    "1500#", "Ring Joint (RTJ)",24.00, 29.50, "—", "SS 304 / R-77"],
  ["1/2\"",   "2500#", "Ring Joint (RTJ)", 0.84,  1.88, "—", "SS 304 / R-12"],
  ["3/4\"",   "2500#", "Ring Joint (RTJ)", 1.05,  2.50, "—", "SS 304 / R-14"],
  ["1\"",     "2500#", "Ring Joint (RTJ)", 1.32,  2.88, "—", "SS 304 / R-18"],
  ["1-1/2\"", "2500#", "Ring Joint (RTJ)", 1.90,  3.75, "—", "SS 304 / R-23"],
  ["2\"",     "2500#", "Ring Joint (RTJ)", 2.38,  4.50, "—", "SS 304 / R-26"],
  ["3\"",     "2500#", "Ring Joint (RTJ)", 3.50,  5.88, "—", "SS 304 / R-35"],
  ["4\"",     "2500#", "Ring Joint (RTJ)", 4.50,  7.25, "—", "SS 304 / R-39"],
  ["6\"",     "2500#", "Ring Joint (RTJ)", 6.63,  9.25, "—", "SS 304 / R-46"],
  ["8\"",     "2500#", "Ring Joint (RTJ)", 8.63, 11.75, "—", "SS 304 / R-50"],
  ["10\"",    "2500#", "Ring Joint (RTJ)",10.75, 14.25, "—", "SS 304 / R-54"],
  ["12\"",    "2500#", "Ring Joint (RTJ)",12.75, 17.00, "—", "SS 304 / R-58"],
];

// Flange Face Finish & Gasket Pairing Reference
export const flangeFaceHeaders = ["Face Type", "Abbr.", "Classes", "Surface Finish (µin)", "Recommended Gasket", "Notes"];
export const flangeFaceRows: (string | number)[][] = [
  ["Raised Face",         "RF",  "150#-900#",  "125-250", "Spiral Wound (CGI)",    "Most common; 1/16\" raised for 150/300, 1/4\" for 600+"],
  ["Raised Face",         "RF",  "150#-300#",  "125-250", "Flat Non-Asbestos",     "Suitable for low-pressure, non-critical service"],
  ["Raised Face",         "RF",  "150#-600#",  "125-250", "PTFE Envelope",         "Chemical resistance; FDA/pharma applications"],
  ["Raised Face",         "RF",  "300#-900#",  "125-250", "Spiral Wound (SS/Graph)","Higher pressure; inner ring recommended >= 600#"],
  ["Raised Face",         "RF",  "150#-300#",  "125-250", "Compressed Fiber",      "Budget option for water/air <= 300 F"],
  ["Ring Type Joint",     "RTJ", "600#-2500#", "63-125",  "Ring Gasket (Oval)",     "Metal-to-metal seal; oval preferred for new work"],
  ["Ring Type Joint",     "RTJ", "600#-2500#", "63-125",  "Ring Gasket (Octagonal)","Tighter seal than oval; not reusable"],
  ["Ring Type Joint",     "RTJ", "900#-2500#", "63-125",  "Ring Gasket (BX)",       "API 6A; extreme pressure (wellhead/subsea)"],
  ["Flat Face",           "FF",  "150#-300#",  "250-500", "Full-Face Flat",         "Must use full-face gasket; never bolt FF to RF"],
  ["Flat Face",           "FF",  "150#",       "250-500", "Full-Face Rubber",       "Cast iron / ductile iron flanges; low pressure"],
  ["Flat Face",           "FF",  "150#-300#",  "250-500", "Full-Face PTFE",         "Chemical service with CI or lined flanges"],
  ["Tongue & Groove",     "T&G", "150#-2500#", "63-125",  "Spiral Wound (no ring)", "Self-centering; confined gasket area"],
  ["Tongue & Groove",     "T&G", "600#-2500#", "63-125",  "Solid Metal (soft iron)","High temp/pressure; steam & hydrocarbon"],
  ["Male & Female",       "M&F", "150#-2500#", "63-125",  "Flat or Spiral Wound",  "Confined gasket; limits blowout risk"],
  ["Lens Ring",           "LR",  "API 10K+",   "32-63",   "Lens Ring (metal)",      "Very high pressure; self-energizing seal"],
];

// Valve Cv Flow Coefficients
export const valveCvHeaders = ["Pipe Size", "Valve Type", "Cv (Full Open)", "Port Type", "Pressure Drop (psi @10 GPM)"];
export const valveCvRows: (string | number)[][] = [
  ["1/2\"",  "Gate",        14,   "Full",    0.51],
  ["1/2\"",  "Globe",        5,   "Full",    4.00],
  ["1/2\"",  "Ball",        15,   "Full",    0.44],
  ["1/2\"",  "Ball",         7,   "Reduced", 2.04],
  ["1/2\"",  "Butterfly",   10,   "Full",    1.00],
  ["3/4\"",  "Gate",        23,   "Full",    0.19],
  ["3/4\"",  "Globe",       10,   "Full",    1.00],
  ["3/4\"",  "Ball",        30,   "Full",    0.11],
  ["3/4\"",  "Ball",        14,   "Reduced", 0.51],
  ["1\"",    "Gate",        35,   "Full",    0.08],
  ["1\"",    "Globe",       15,   "Full",    0.44],
  ["1\"",    "Ball",        50,   "Full",    0.04],
  ["1\"",    "Ball",        25,   "Reduced", 0.16],
  ["1\"",    "Butterfly",   35,   "Full",    0.08],
  ["1-1/4\"","Gate",        55,   "Full",    0.03],
  ["1-1/4\"","Globe",       22,   "Full",    0.21],
  ["1-1/4\"","Ball",        75,   "Full",    0.02],
  ["1-1/2\"","Gate",        80,   "Full",    0.02],
  ["1-1/2\"","Globe",       30,   "Full",    0.11],
  ["1-1/2\"","Ball",       110,   "Full",    0.01],
  ["1-1/2\"","Ball",        50,   "Reduced", 0.04],
  ["1-1/2\"","Butterfly",   80,   "Full",    0.02],
  ["2\"",    "Gate",       120,   "Full",    0.01],
  ["2\"",    "Globe",       50,   "Full",    0.04],
  ["2\"",    "Ball",       170,   "Full",    0.003],
  ["2\"",    "Ball",        80,   "Reduced", 0.02],
  ["2\"",    "Butterfly",  150,   "Full",    0.004],
  ["2-1/2\"","Gate",       200,   "Full",    0.003],
  ["2-1/2\"","Globe",       80,   "Full",    0.02],
  ["2-1/2\"","Ball",       250,   "Full",    0.002],
  ["3\"",    "Gate",       300,   "Full",    0.001],
  ["3\"",    "Globe",      120,   "Full",    0.01],
  ["3\"",    "Ball",       400,   "Full",    0.001],
  ["3\"",    "Butterfly",  300,   "Full",    0.001],
  ["4\"",    "Gate",       500,   "Full",    0.0004],
  ["4\"",    "Globe",      200,   "Full",    0.003],
  ["4\"",    "Ball",       750,   "Full",    0.0002],
  ["4\"",    "Butterfly",  600,   "Full",    0.0003],
  ["6\"",    "Gate",      1100,   "Full",    0.0001],
  ["6\"",    "Globe",      450,   "Full",    0.0005],
  ["6\"",    "Ball",      1500,   "Full",    0.00004],
  ["6\"",    "Butterfly", 1300,   "Full",    0.00006],
  ["8\"",    "Gate",      1900,   "Full",    0.00003],
  ["8\"",    "Ball",      2800,   "Full",    0.00001],
  ["8\"",    "Butterfly", 2200,   "Full",    0.00002],
  ["10\"",   "Gate",      3000,   "Full",    0.00001],
  ["10\"",   "Butterfly", 3800,   "Full",    0.000007],
  ["12\"",   "Gate",      4500,   "Full",    0.000005],
  ["12\"",   "Butterfly", 5500,   "Full",    0.000003],
];

// Steam table data
export const steamTableHeaders = ["Pressure (PSIG)", "Temp (°F)", "Enthalpy (BTU/lb)", "Specific Vol (ft³/lb)"];
export const steamTableRows: (string | number)[][] = [
  [0, 212, 1150.4, 26.80], [5, 227, 1156.2, 20.09], [10, 240, 1160.6, 16.30],
  [15, 250, 1164.1, 13.75], [20, 259, 1167.1, 11.90], [25, 267, 1169.7, 10.50],
  [30, 274, 1172.0, 9.40], [40, 287, 1175.9, 7.79], [50, 298, 1179.1, 6.65],
  [60, 307, 1181.9, 5.82], [70, 316, 1184.2, 5.17], [80, 324, 1186.3, 4.67],
  [90, 331, 1188.1, 4.23], [100, 338, 1189.7, 3.88], [125, 353, 1193.0, 3.23],
  [150, 366, 1195.6, 2.75], [175, 377, 1197.6, 2.40], [200, 388, 1199.3, 2.13],
  [250, 406, 1201.7, 1.74], [300, 422, 1203.2, 1.47], [350, 436, 1204.1, 1.27],
  [400, 448, 1204.5, 1.12], [450, 460, 1204.4, 0.99], [500, 470, 1204.0, 0.88],
  [600, 489, 1202.2, 0.73],
];

// Friction Loss / Equivalent Length data
export const PIPE_MATERIALS_HW: { label: string; c: number; ids: { name: string; id: number }[] }[] = [
  {
    label: "Steel (Sch 40)", c: 120,
    ids: [
      { name: "1/2\"", id: 0.622 }, { name: "3/4\"", id: 0.824 }, { name: "1\"", id: 1.049 },
      { name: "1-1/4\"", id: 1.380 }, { name: "1-1/2\"", id: 1.610 }, { name: "2\"", id: 2.067 },
      { name: "2-1/2\"", id: 2.469 }, { name: "3\"", id: 3.068 }, { name: "4\"", id: 4.026 },
      { name: "6\"", id: 6.065 }, { name: "8\"", id: 7.981 }, { name: "10\"", id: 10.020 },
      { name: "12\"", id: 12.000 },
    ],
  },
  {
    label: "Copper (Type L)", c: 140,
    ids: [
      { name: "1/2\"", id: 0.545 }, { name: "3/4\"", id: 0.785 }, { name: "1\"", id: 1.025 },
      { name: "1-1/4\"", id: 1.265 }, { name: "1-1/2\"", id: 1.505 }, { name: "2\"", id: 1.985 },
      { name: "2-1/2\"", id: 2.465 }, { name: "3\"", id: 2.945 }, { name: "4\"", id: 3.905 },
    ],
  },
  {
    label: "PVC (Sch 40)", c: 150,
    ids: [
      { name: "1/2\"", id: 0.622 }, { name: "3/4\"", id: 0.824 }, { name: "1\"", id: 1.049 },
      { name: "1-1/4\"", id: 1.380 }, { name: "1-1/2\"", id: 1.610 }, { name: "2\"", id: 2.067 },
      { name: "3\"", id: 3.068 }, { name: "4\"", id: 4.026 }, { name: "6\"", id: 6.065 },
    ],
  },
  {
    label: "CPVC", c: 150,
    ids: [
      { name: "1/2\"", id: 0.546 }, { name: "3/4\"", id: 0.742 }, { name: "1\"", id: 0.957 },
      { name: "1-1/4\"", id: 1.278 }, { name: "1-1/2\"", id: 1.500 }, { name: "2\"", id: 1.939 },
      { name: "3\"", id: 2.900 }, { name: "4\"", id: 3.826 },
    ],
  },
  {
    label: "Stainless Steel (Sch 40S)", c: 120,
    ids: [
      { name: "1/2\"", id: 0.622 }, { name: "3/4\"", id: 0.824 }, { name: "1\"", id: 1.049 },
      { name: "1-1/2\"", id: 1.610 }, { name: "2\"", id: 2.067 }, { name: "3\"", id: 3.068 },
      { name: "4\"", id: 4.026 }, { name: "6\"", id: 6.065 },
    ],
  },
];

// Equivalent length data (feet) per fitting per pipe size
export const EQ_LENGTH_DATA: Record<string, Record<string, number>> = {
  "1/2\"":  { "90° Elbow": 1.5, "45° Elbow": 0.8, "90° Long Radius": 1.0, "Tee (thru)": 1.0, "Tee (branch)": 3.0, "Gate Valve": 0.3, "Globe Valve": 17, "Ball Valve": 0.2, "Check Valve (swing)": 4.0, "Butterfly Valve": 0 },
  "3/4\"":  { "90° Elbow": 2.0, "45° Elbow": 1.0, "90° Long Radius": 1.3, "Tee (thru)": 1.3, "Tee (branch)": 4.0, "Gate Valve": 0.4, "Globe Valve": 22, "Ball Valve": 0.3, "Check Valve (swing)": 5.0, "Butterfly Valve": 0 },
  "1\"":    { "90° Elbow": 2.5, "45° Elbow": 1.2, "90° Long Radius": 1.7, "Tee (thru)": 1.7, "Tee (branch)": 5.0, "Gate Valve": 0.5, "Globe Valve": 27, "Ball Valve": 0.3, "Check Valve (swing)": 6.5, "Butterfly Valve": 0 },
  "1-1/4\"":{ "90° Elbow": 3.5, "45° Elbow": 1.7, "90° Long Radius": 2.3, "Tee (thru)": 2.3, "Tee (branch)": 6.5, "Gate Valve": 0.7, "Globe Valve": 35, "Ball Valve": 0.4, "Check Valve (swing)": 8.0, "Butterfly Valve": 0 },
  "1-1/2\"":{ "90° Elbow": 4.0, "45° Elbow": 2.0, "90° Long Radius": 2.5, "Tee (thru)": 2.5, "Tee (branch)": 7.5, "Gate Valve": 0.8, "Globe Valve": 45, "Ball Valve": 0.5, "Check Valve (swing)": 10, "Butterfly Valve": 0 },
  "2\"":    { "90° Elbow": 5.0, "45° Elbow": 2.5, "90° Long Radius": 3.5, "Tee (thru)": 3.5, "Tee (branch)": 10, "Gate Valve": 1.0, "Globe Valve": 55, "Ball Valve": 0.7, "Check Valve (swing)": 12, "Butterfly Valve": 6 },
  "2-1/2\"":{ "90° Elbow": 6.0, "45° Elbow": 3.0, "90° Long Radius": 4.0, "Tee (thru)": 4.0, "Tee (branch)": 12, "Gate Valve": 1.2, "Globe Valve": 65, "Ball Valve": 0.8, "Check Valve (swing)": 14, "Butterfly Valve": 7 },
  "3\"":    { "90° Elbow": 7.5, "45° Elbow": 3.8, "90° Long Radius": 5.0, "Tee (thru)": 5.0, "Tee (branch)": 15, "Gate Valve": 1.5, "Globe Valve": 84, "Ball Valve": 1.0, "Check Valve (swing)": 17, "Butterfly Valve": 10 },
  "4\"":    { "90° Elbow": 10, "45° Elbow": 5.0, "90° Long Radius": 6.5, "Tee (thru)": 6.5, "Tee (branch)": 20, "Gate Valve": 2.0, "Globe Valve": 110, "Ball Valve": 1.3, "Check Valve (swing)": 22, "Butterfly Valve": 12 },
  "6\"":    { "90° Elbow": 15, "45° Elbow": 7.5, "90° Long Radius": 10, "Tee (thru)": 10, "Tee (branch)": 30, "Gate Valve": 3.0, "Globe Valve": 170, "Ball Valve": 2.0, "Check Valve (swing)": 33, "Butterfly Valve": 18 },
  "8\"":    { "90° Elbow": 20, "45° Elbow": 10, "90° Long Radius": 13, "Tee (thru)": 13, "Tee (branch)": 40, "Gate Valve": 4.0, "Globe Valve": 220, "Ball Valve": 2.5, "Check Valve (swing)": 45, "Butterfly Valve": 25 },
  "10\"":   { "90° Elbow": 25, "45° Elbow": 12, "90° Long Radius": 16, "Tee (thru)": 16, "Tee (branch)": 50, "Gate Valve": 5.0, "Globe Valve": 280, "Ball Valve": 3.0, "Check Valve (swing)": 55, "Butterfly Valve": 30 },
  "12\"":   { "90° Elbow": 30, "45° Elbow": 15, "90° Long Radius": 20, "Tee (thru)": 20, "Tee (branch)": 60, "Gate Valve": 6.0, "Globe Valve": 340, "Ball Valve": 4.0, "Check Valve (swing)": 66, "Butterfly Valve": 35 },
};

export const FITTING_TYPES = [
  "90° Elbow", "45° Elbow", "90° Long Radius", "Tee (thru)", "Tee (branch)",
  "Gate Valve", "Globe Valve", "Ball Valve", "Check Valve (swing)", "Butterfly Valve",
];

export const EQ_PIPE_SIZES = Object.keys(EQ_LENGTH_DATA);

export const EQ_MATERIALS: { label: string; c: number; ids: Record<string, number> }[] = [
  { label: "Steel (Sch 40)", c: 120, ids: { "1/2\"": 0.622, "3/4\"": 0.824, "1\"": 1.049, "1-1/4\"": 1.380, "1-1/2\"": 1.610, "2\"": 2.067, "2-1/2\"": 2.469, "3\"": 3.068, "4\"": 4.026, "6\"": 6.065, "8\"": 7.981, "10\"": 10.020, "12\"": 12.000 } },
  { label: "Copper (Type L)", c: 140, ids: { "1/2\"": 0.545, "3/4\"": 0.785, "1\"": 1.025, "1-1/4\"": 1.265, "1-1/2\"": 1.505, "2\"": 1.985, "2-1/2\"": 2.465, "3\"": 2.945, "4\"": 3.905 } },
  { label: "PVC (Sch 40)", c: 150, ids: { "1/2\"": 0.622, "3/4\"": 0.824, "1\"": 1.049, "1-1/4\"": 1.380, "1-1/2\"": 1.610, "2\"": 2.067, "3\"": 3.068, "4\"": 4.026, "6\"": 6.065 } },
];

// GPM Sizing Materials
export const GPM_SIZING_MATERIALS: { label: string; c: number; sizes: { name: string; id: number }[] }[] = [
  {
    label: "Steel (Sch 40)", c: 120,
    sizes: [
      { name: "1/2\"", id: 0.622 }, { name: "3/4\"", id: 0.824 }, { name: "1\"", id: 1.049 },
      { name: "1-1/4\"", id: 1.380 }, { name: "1-1/2\"", id: 1.610 }, { name: "2\"", id: 2.067 },
      { name: "2-1/2\"", id: 2.469 }, { name: "3\"", id: 3.068 }, { name: "4\"", id: 4.026 },
      { name: "5\"", id: 5.047 }, { name: "6\"", id: 6.065 }, { name: "8\"", id: 7.981 },
      { name: "10\"", id: 10.020 }, { name: "12\"", id: 12.000 },
    ],
  },
  {
    label: "Copper (Type L)", c: 140,
    sizes: [
      { name: "1/2\"", id: 0.545 }, { name: "3/4\"", id: 0.785 }, { name: "1\"", id: 1.025 },
      { name: "1-1/4\"", id: 1.265 }, { name: "1-1/2\"", id: 1.505 }, { name: "2\"", id: 1.985 },
      { name: "2-1/2\"", id: 2.465 }, { name: "3\"", id: 2.945 }, { name: "4\"", id: 3.905 },
    ],
  },
  {
    label: "PVC (Sch 40)", c: 150,
    sizes: [
      { name: "1/2\"", id: 0.622 }, { name: "3/4\"", id: 0.824 }, { name: "1\"", id: 1.049 },
      { name: "1-1/4\"", id: 1.380 }, { name: "1-1/2\"", id: 1.610 }, { name: "2\"", id: 2.067 },
      { name: "3\"", id: 3.068 }, { name: "4\"", id: 4.026 }, { name: "6\"", id: 6.065 },
    ],
  },
  {
    label: "CPVC", c: 150,
    sizes: [
      { name: "1/2\"", id: 0.546 }, { name: "3/4\"", id: 0.742 }, { name: "1\"", id: 0.957 },
      { name: "1-1/4\"", id: 1.278 }, { name: "1-1/2\"", id: 1.500 }, { name: "2\"", id: 1.939 },
      { name: "3\"", id: 2.900 }, { name: "4\"", id: 3.826 },
    ],
  },
  {
    label: "Stainless Steel (Sch 40S)", c: 120,
    sizes: [
      { name: "1/2\"", id: 0.622 }, { name: "3/4\"", id: 0.824 }, { name: "1\"", id: 1.049 },
      { name: "1-1/2\"", id: 1.610 }, { name: "2\"", id: 2.067 }, { name: "3\"", id: 3.068 },
      { name: "4\"", id: 4.026 }, { name: "6\"", id: 6.065 },
    ],
  },
];

export const VELOCITY_PRESETS = [
  { label: "HVAC / Comfort (4-8 ft/s)", min: 4, max: 8 },
  { label: "Domestic Water (3-5 ft/s)", min: 3, max: 5 },
  { label: "Process / Industrial (5-10 ft/s)", min: 5, max: 10 },
  { label: "Fire Protection (≤15 ft/s)", min: 1, max: 15 },
  { label: "Custom", min: 0, max: 0 },
];

// Max GPM Materials
export const MAX_GPM_VELOCITIES = [4, 5, 6, 8, 10, 15];
export const MAX_GPM_MATERIALS: { label: string; sizes: { name: string; id: number }[] }[] = [
  {
    label: "Steel (Sch 40)",
    sizes: [
      { name: "1/2\"", id: 0.622 }, { name: "3/4\"", id: 0.824 }, { name: "1\"", id: 1.049 },
      { name: "1-1/4\"", id: 1.380 }, { name: "1-1/2\"", id: 1.610 }, { name: "2\"", id: 2.067 },
      { name: "2-1/2\"", id: 2.469 }, { name: "3\"", id: 3.068 }, { name: "4\"", id: 4.026 },
      { name: "5\"", id: 5.047 }, { name: "6\"", id: 6.065 }, { name: "8\"", id: 7.981 },
      { name: "10\"", id: 10.020 }, { name: "12\"", id: 12.000 },
    ],
  },
  {
    label: "Copper (Type L)",
    sizes: [
      { name: "1/2\"", id: 0.545 }, { name: "3/4\"", id: 0.785 }, { name: "1\"", id: 1.025 },
      { name: "1-1/4\"", id: 1.265 }, { name: "1-1/2\"", id: 1.505 }, { name: "2\"", id: 1.985 },
      { name: "2-1/2\"", id: 2.465 }, { name: "3\"", id: 2.945 }, { name: "4\"", id: 3.905 },
    ],
  },
  {
    label: "PVC (Sch 40)",
    sizes: [
      { name: "1/2\"", id: 0.622 }, { name: "3/4\"", id: 0.824 }, { name: "1\"", id: 1.049 },
      { name: "1-1/4\"", id: 1.380 }, { name: "1-1/2\"", id: 1.610 }, { name: "2\"", id: 2.067 },
      { name: "3\"", id: 3.068 }, { name: "4\"", id: 4.026 }, { name: "6\"", id: 6.065 },
    ],
  },
  {
    label: "CPVC",
    sizes: [
      { name: "1/2\"", id: 0.546 }, { name: "3/4\"", id: 0.742 }, { name: "1\"", id: 0.957 },
      { name: "1-1/4\"", id: 1.278 }, { name: "1-1/2\"", id: 1.500 }, { name: "2\"", id: 1.939 },
      { name: "3\"", id: 2.900 }, { name: "4\"", id: 3.826 },
    ],
  },
  {
    label: "Stainless Steel (Sch 40S)",
    sizes: [
      { name: "1/2\"", id: 0.622 }, { name: "3/4\"", id: 0.824 }, { name: "1\"", id: 1.049 },
      { name: "1-1/2\"", id: 1.610 }, { name: "2\"", id: 2.067 }, { name: "3\"", id: 3.068 },
      { name: "4\"", id: 4.026 }, { name: "6\"", id: 6.065 },
    ],
  },
];
